<script setup>
/* eslint-disable no-unused-vars */
/* global defineProps, defineEmits */
import auth from '@/api/auth/auth';

import { onMounted } from "vue";
import { useRoute } from "vue-router";

const route = useRoute();

onMounted(() => {
  // Solo forzar el logout/limpieza de sesión al aterrizar en /login (para permitir
  // iniciar sesión con otro usuario). En recover-password / confirm-password-reset
  // no debe redirigir: son rutas públicas propias que llegan por enlace directo
  // (ej. el enlace del email de restablecimiento) y auth.logout() empujaría a
  // 'login' perdiendo el token de la URL.
  if (route.name === 'login') {
    auth.logout();
  }
});
</script>

<template>
  <div
    id="auth"
    class="vertical text-center animated fadeIn fast"
  >
    <router-view />
  </div>
</template>

<style lang="scss" scoped>
  #auth {
    width: 100%;
    height: 100%;
    // background-image: url('../../assets/images/login_pattern-bg.jpg');
  }
</style>
